import { render, staticRenderFns } from "./YouTubeActionForm.vue?vue&type=template&id=289d70a3&scoped=true"
import script from "./YouTubeActionForm.vue?vue&type=script&lang=js"
export * from "./YouTubeActionForm.vue?vue&type=script&lang=js"
import style0 from "./YouTubeActionForm.vue?vue&type=style&index=0&id=289d70a3&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "289d70a3",
  null
  
)

export default component.exports